import { AcceptanceStatus, DataKYCFileTctWithFile } from '@dealstack/shared/lib/generated';
import { ButtonVariant } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/Review/component/KycActionButton/KycActionButton.types';

export const isKycDisabled = ({
	selectedKycFile,
	variant,
}: {
	selectedKycFile?: DataKYCFileTctWithFile;
	variant: ButtonVariant;
}) => {
	if (!selectedKycFile) {
		return true;
	}

	if (variant === 'decline') {
		if (
			selectedKycFile.status === AcceptanceStatus.REJECTED ||
			selectedKycFile.status === AcceptanceStatus.REREQUESTED
		) {
			return true;
		}
	}

	return false;
};
